import { render, staticRenderFns } from "./family-importer-page.vue?vue&type=template&id=f9f14f66&"
import script from "./family-importer-page.vue?vue&type=script&lang=js&"
export * from "./family-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports